(function () {
  'use strict';

  // Concern slider: mounts Splide and wires the section's own arrow buttons.
  // The arrows live outside the Splide root (header on tablet/desktop, under
  // the row on mobile), so Splide's built-in ones are off.

  function setup(root) {
    var el = root.querySelector('.concerns__splide');
    if (!el || el._concernsReady || !window.Splide) return;
    el._concernsReady = true;

    var splide = new Splide(el).mount();
    var prevBtns = root.querySelectorAll('[data-concerns-prev]');
    var nextBtns = root.querySelectorAll('[data-concerns-next]');

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { splide.go('<'); });
    });
    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { splide.go('>'); });
    });

    // "At the start / at the end" is read from where the row actually is (or
    // is heading), not from the slide index: several cards are visible at
    // once, so the row stops moving before the index reaches the last card.
    function updateState(targetIndex) {
      var move = splide.Components.Move;
      var position = typeof targetIndex === 'number' ? move.toPosition(targetIndex, true) : move.getPosition();
      var atStart = Math.abs(position - move.toPosition(0, true)) < 1;
      var atEnd = Math.abs(position - move.toPosition(splide.length - 1, true)) < 1;

      prevBtns.forEach(function (btn) { btn.disabled = atStart; });
      nextBtns.forEach(function (btn) { btn.disabled = atEnd; });
      // The edge fades follow the same state: left once scrolled, right until
      // the last card is in (see the CSS).
      root.classList.toggle('is-scrolled', !atStart);
      root.classList.toggle('is-at-end', atEnd);
    }

    // `move` fires as the slide starts, with the index it is heading to, so
    // the fade is already gone by the time the last card arrives.
    splide.on('move', function (newIndex, prevIndex, destIndex) {
      updateState(typeof destIndex === 'number' ? destIndex : newIndex);
    });
    splide.on('mounted moved dragged resized', function () { updateState(); });
    updateState();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-concerns-root]').forEach(setup);
  }

  function boot(scope) {
    if (window.Splide) {
      init(scope);
    } else {
      document.addEventListener('splide:ready', function () { init(scope); }, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme Editor / hot reload swap the markup without re-running this file.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
